import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { DiscountListPage } from '@/features/discounts'

export const Route = createFileRoute('/_authenticated/billing/discounts')({
  component: () => (
    <RequirePermission permission='discounts.read'>
      <DiscountListPage />
    </RequirePermission>
  ),
})
